/* global URLSearchParams */
import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";

export default function AuthCallback() {
  const { exchangeGoogleSession } = useAuth();
  const navigate = useNavigate();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = window.location.hash;
    const params = new URLSearchParams(hash.replace(/^#/, ""));
    const sid = params.get("session_id");
    if (!sid) {
      navigate("/login");
      return;
    }
    (async () => {
      try {
        await exchangeGoogleSession(sid);
        // Clean hash and go to dashboard
        window.history.replaceState(null, "", "/app");
        navigate("/app");
      } catch (e) {
        toast.error("Google sign-in failed");
        navigate("/login");
      }
    })();
  }, [exchangeGoogleSession, navigate]);

  return (
    <div className="min-h-screen bg-zinc-950 grid place-items-center" data-testid="auth-callback">
      <div className="text-zinc-400 flex items-center gap-2 text-sm">
        <Loader2 className="w-4 h-4 animate-spin" />
        Signing you in…
      </div>
    </div>
  );
}
